import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryCampaignsAvailableDatesData =
  Offers.Components['GetCampaignAvailableDatesResponse'];

interface UseQueryCampaignsAvailableDatesOptions {
  enabled?: boolean;
}

interface UseQueryCampaignsAvailableDatesParameters {
  adultsNumber: string;
  brand?: Content.Properties.Brand;
  campaignId: string;
  childrenAges: string;
  departureIds: string;
  destinationIds: string;
  destinationRegionIds?: string;
  durationType: string;
  hotelIds?: string;
}

const useQueryCampaignsAvailableDates = (
  parameters: UseQueryCampaignsAvailableDatesParameters,
  options?: UseQueryCampaignsAvailableDatesOptions,
) => {
  const locale = getLocale();

  const query = useQuery<UseQueryCampaignsAvailableDatesData>(
    [QueryId.CAMPAIGNS_AVAILABLE_DATES, parameters, locale],
    async () => {
      const fetchUrl = '/api/campaigns/available-dates';
      const searchParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${fetchUrl}?${searchParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryCampaignsAvailableDates', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: options?.enabled,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryCampaignsAvailableDates;
